
import RcDomainObject from "../../common/RcDomainObject";

import StringUtils from '@/utils/StringUtils.js'

export default class Address extends RcDomainObject {
  
  static MODEL_NAME = "Address";
      
  static FIELDS = {
    NAME : 'name',
    TYPE: 'type',
    DESCRIPTION: 'description',
    STREET: 'street',
    UNIT: 'unit',
    CITY : 'city',
    JURISDICTION: 'jurisdiction',
    COUNTRY: 'country',
    POSTAL: 'postal',
    ADDRESS: 'address',
    LAT: 'lat',
    LON: 'lon',
  }
  
  constructor(domain, data) {
    super(domain, data, Address.MODEL_NAME);
  }

  isComplete() {
    let complete = true;
    if (StringUtils.isEmpty(this.street())) {
      complete = false;
    }
    if (StringUtils.isEmpty(this.city())) {
      complete = false;
    }
    if (StringUtils.isEmpty(this.province())) {
      complete = false;
    }
    if (StringUtils.isEmpty(this.country())) {
      complete = false;
      if (StringUtils.isEmpty(this.postal())) {
        complete = false;
      }
    }
    return complete;
  }

  fields() {
    return Address.FIELDS;
  }
  
  find() {
    return this.domain.addresses().findById(this.id());
  }
  
  withName(name) {
    this.put(Address.FIELDS.NAME, name);
    return this;
  }

  name() {
    return this.getString(Address.FIELDS.NAME);
  }
  
  withDescription(name) {
    this.put(Address.FIELDS.DESCRIPTION, name);
    return this;
  }

  description() {
    return this.getString(Address.FIELDS.DESCRIPTION);
  }

  copy() {
    var data = this._copy();
    return new Address(this.domain, data);
  }
  
  country() {
    return this.getString(Address.FIELDS.COUNTRY);
  }
  
  withCountry(value) {
    this.put(Address.FIELDS.COUNTRY, value);
    return this;
  }
  
  jurisdiction() {
    return this.province();
  }
  
  province() {
    return this.getString(Address.FIELDS.JURISDICTION);
  }
  
  withProvince(value) {
    this.put(Address.FIELDS.JURISDICTION, value);
    return this;
  }

  unit() {
    return this.getString(Address.FIELDS.UNIT);
  }
  
  postal() {
    return this.getString(Address.FIELDS.POSTAL);
  }
  
  withPostal(value) {
    this.put(Address.FIELDS.POSTAL, value);
    return this;
  }
  
  city() {
    return this.getString(Address.FIELDS.CITY);
  }
  
  withCity(value) {
    this.put(Address.FIELDS.CITY, value);
    return this;
  }
  
  street() {
    return this.getString(Address.FIELDS.STREET);
  }
  
  withStreet(value) {
    this.put(Address.FIELDS.STREET, value);
    return this;
  }

  type() {
    return this.getString(Address.FIELDS.TYPE);
  }
  
  withTypePoi() {
    return this.withType("poi");
  }

  withType(type) {
    this.put(Address.FIELDS.TYPE, type);
    return this;
  }

  isTypePoi() {
    return this.type() === 'poi';
  }

  location() {
    return StringUtils.format("{0} {1} {2} {3} {4}", 
        [this.street(), this.unit(), this.city(), 
        this.province(), this.postal()]);
  }
  
  isCanada() {
    var c = this.country();
    if (c) {
      if (c.toLowerCase() === "canada") {
        return true;
      }
    }
    return false;
  }

  ownerId() {
    return this.getString("ownerId");
  }

  hasDifferentOwner(company) {
    return this.ownerId() !== company.id();
  }
  
  latitude() {
    return this.get(Address.FIELDS.LAT);
  }

  longitude() {
    return this.get(Address.FIELDS.LON);
  }

  withGpsLocation(lat, lon) {
    this.put(Address.FIELDS.LAT, lat);
    this.put(Address.FIELDS.LON, lon);
    return this;
  }
  
  gpsLocation() {
    return StringUtils.format("{0},{1}", this.latitude(), this.longitude())
  }
}